import { FormEditorComponent } from "@/components/forms/components/FormEditorComponent.tsx";
import { FormEditorProvider } from "@/components/forms/FormEditorContext.tsx";
import { FormEditorTypes } from "@/components/forms/form-editor.config.ts";

export interface FormEditorProps {
  type: FormEditorTypes;
  id: number;
  containerSelector?: string;
  readOnly?: boolean;
}

export const FormEditor = ({ type, id, readOnly }: FormEditorProps) => {
  return (
    <>
      <FormEditorProvider type={type} id={id} readOnly={readOnly}>
        <FormEditorComponent />
      </FormEditorProvider>
    </>
  );
};
